import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {Link} from "react-router-dom";
import { thisBaseURL} from "../../utils/helper.js";
import { useLocation } from 'react-router-dom';
import css from "../../css/common.module.css";

function HomePage({signedIn}) {
	const slides = [
	    { href: thisBaseURL+"/foods/eggs-shell", img: "images/WorldFactbook-EggFact.png" },
	    { href: thisBaseURL+"/foods/honey", img: "images/WorldFactbook-HoneyFact.png" },
	    { href: thisBaseURL+"/foods/oranges", img: "images/WorldFactbook-OrangeFact.png" },
	    { href: thisBaseURL+"/foods/shrimp", img: "images/WorldFactbook-ShrimpFact.png" }
	];
	const location = useLocation();
	const renderSlides = () =>
	    slides.map(slide => (
	      <div>
	        <a href={slide.href} >
	        	<img alt="Learn more" style={{textAlign:"center", margin:"0 auto", width: "75%", height: "35vh"}} src={slide.img} />
	        </a>
	      </div>
    ));
  	return (
	<>
	    <div id="page">
        	<div className="page-inner">
        		{location.state && location.state.errorMessage && (
				<div className={"container-fluid viewh-85 " + css.bg}>
					<div className="row">
						<div className="col-md-4 col-sm-4 mt-8"></div>
						<div className="col-md-4 col-sm-4 mt-2">
							<div id="inerrorMessage" className={css.errorblock}>
								{location.state.errorMessage}
							</div>
						</div>
						<div className="col-md-4 col-sm-4 mt-8"></div>
					</div>
				</div>
				)}
	          	<div id="main">
	          	{signedIn && 
	          	(<div style={{backgroundColor: "#1d7d16", color: "white"}}>
					  <p>Signed in successfully.</p>
				</div>
				)}
	         	 <Slider 
	         	 	dots={true}
	         	 	slidesToShow={1}
			        slidesToScroll={1}
			        autoplay={true}
			        autoplaySpeed={3000}
			        >
			        	{renderSlides()}
			        </Slider>
			        <div className="links">
				        <Link reloadDocument to="/foods">
							<img alt="Browse Foods" src="images/FoodIcon.png" />
							<span>Browse Foods</span>
						</Link>
						<Link reloadDocument to="/countries">
							<img alt="Browse Countries" src="images/CountriesIcon.png" />
							<span>Browse Countries</span>
						</Link>
						<Link to="/about">
							<img alt="About Us" src="images/AboutUsIcon.png" />
							<span>About Us</span>
						</Link>
					</div>
				</div>
			</div>
		</div>
	</>
  );
}
export default HomePage;
